<div class="staff-section container-fluid">

  <div class="alert alert-danger alert-dismissible fade show" *ngIf="errorMessage" role="alert">
    <mat-icon>error</mat-icon>
    <span class="ms-2">{{ errorMessage }}</span>
    <button type="button" class="btn-close" (click)="clearError()"></button>
  </div>

  <div class="section-header mb-4">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h6 class="fw-bold mb-1">Personal del Centro de Trabajo</h6>
            <p class="text-muted mb-0">Gestiona el personal asignado a este centro de trabajo (modificar nombre, color y estado)</p>
          </div>
          <div>
            <button mat-raised-button class="factuone-button" (click)="openStaffDialog()" [disabled]="isLoadingStatuses">
              <mat-icon>person_add</mat-icon>
              Agregar Personal
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Buscar personal</mat-label>
          <input matInput 
                 [value]="searchTerm" 
                 (input)="onSearchChange($any($event.target).value)" 
                 placeholder="Buscar por nombre, email...">
          <mat-icon matPrefix>search</mat-icon>
          <mat-icon matSuffix class="cf-spin-icon" *ngIf="isLoading">autorenew</mat-icon>
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Estado</mat-label>
          <mat-select [value]="filterStatus" (selectionChange)="onStatusFilterChange($event.value)">
            <mat-option [value]="null">Todos los estados</mat-option>
            <mat-option *ngFor="let status of staffStatuses; trackBy: trackByIndex" [value]="status.statusMerchantStaffId">
              {{ status.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-4 d-flex align-items-center justify-content-end">
        <span class="text-muted">
          <strong>{{ totalItems }}</strong> personal{{ totalItems !== 1 ? 'es' : '' }} total{{ totalItems !== 1 ? 'es' : '' }}
        </span>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading && staff.length === 0" class="loading-state text-center py-5">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    <p class="text-muted">Cargando personal...</p>
  </div>

  <div *ngIf="!isLoading || staff.length > 0" class="staff-content">
    <div *ngIf="staff.length > 0; else emptyState" class="staff-table-container">
      <table class="staff-table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Email</th>
            <th>Teléfono</th>
            <th class="text-center">Estado</th>
            <th class="text-center">Color</th>
            <th class="text-center">Conceptos asignados</th>
            <th class="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let staffMember of staff; trackBy: trackByIndex" class="staff-row">
            <td>
              <div class="staff-info">
                <mat-icon class="staff-icon">person</mat-icon>
                <div class="staff-details">
                  <span class="staff-name">{{ staffMember.displayName }}</span>
                  <span class="staff-full-name text-muted">{{ staffMember.firstName }} {{ staffMember.lastName }}</span>
                </div>
              </div>
            </td>
            <td>
              <span class="staff-email">{{ staffMember.email || '-' }}</span>
            </td>
            <td>
              <span class="staff-phone">{{ staffMember.phone || '-' }}</span>
            </td>
            <td class="text-center">
              <span class="status-badge" 
                    [class.status-active]="staffMember.statusMerchantStaffId === 1" 
                    [class.status-inactive]="staffMember.statusMerchantStaffId === 2"
                    [class.status-archived]="staffMember.statusMerchantStaffId === 3">
                {{ staffMember.statusName }}
              </span>
            </td>
            <td class="text-center">
              <div class="color-indicator" 
                   *ngIf="staffMember.calendarColor" 
                   [style.background-color]="staffMember.calendarColor"
                   [title]="staffMember.calendarColor">
              </div>
              <span class="text-muted" *ngIf="!staffMember.calendarColor">Sin color</span>
            </td>
            <td class="text-center">
              <span class="concepts-count" *ngIf="staffMember.assignedConceptsCount > 0">
                <mat-icon class="small-icon">store</mat-icon>
                {{ staffMember.assignedConceptsCount }}
              </span>
              <span class="text-muted" *ngIf="staffMember.assignedConceptsCount === 0">
                Sin asignar
              </span>
            </td>
            <td class="text-center">
              <div class="action-buttons">
                <button mat-icon-button matTooltip="Editar" (click)="openStaffDialog(staffMember)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Eliminar" color="warn" (click)="confirmDelete(staffMember)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="pagination-container mt-4" *ngIf="totalPages > 1">
        <div class="d-flex justify-content-between align-items-center">
          <div class="pagination-info">
            Página {{ currentPage }} de {{ totalPages }}
          </div>
          <div class="pagination-controls d-flex gap-2">
            <button mat-icon-button 
                    [disabled]="currentPage === 1 || isLoading" 
                    (click)="previousPage()"
                    matTooltip="Página anterior">
              <mat-icon>chevron_left</mat-icon>
            </button>
            
            <button mat-button 
                    *ngFor="let page of [].constructor(totalPages); let i = index; trackBy: trackByIndex"
                    [class.active]="currentPage === i + 1"
                    [disabled]="isLoading"
                    (click)="goToPage(i + 1)">
              {{ i + 1 }}
            </button>
            
            <button mat-icon-button 
                    [disabled]="currentPage === totalPages || isLoading" 
                    (click)="nextPage()"
                    matTooltip="Página siguiente">
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
          <div class="pagination-size">
            {{ pageSize }} por página
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #emptyState>
    <div class="empty-state">
      <mat-icon>people</mat-icon>
      <h5>No hay personal configurado</h5>
      <p class="text-muted">El personal se sincroniza automáticamente desde el sistema de empleados. Una vez sincronizado, podrá editar su nombre para mostrar, color y estado desde aquí.</p>
    </div>
  </ng-template>

</div>
